<div [matTooltip]="rowData[col.tooltipMsgKey] | translate">
  <ng-container *ngIf="col.type === 'lock'">
    <i *ngIf="isLocked()" class="fas fa-lock" ></i>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'date'">
    {{ rowData[col.field] | localDatetimeFormat }}
  </ng-container>
  
  <ng-container *ngIf="col.type === 'calculated'">
    <ng-container *ngIf="rowData.calculated; else entry">
      {{'label.admin.nutrient.calculated' | translate}}
    </ng-container>
    <ng-template #entry>
      {{'label.admin.nutrient.entry' | translate}}
    </ng-template>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'calculatedCheckbox'">
    <mat-checkbox *ngIf="!rowData.calculated" disabled="true" [ngModel]="!rowData[col.field]"></mat-checkbox>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'calculatedCheckboxInvert'">
    <mat-checkbox *ngIf="!rowData.calculated" disabled="true" [ngModel]="rowData[col.field]"></mat-checkbox>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'long-text'">
    <textarea rows="3" class="textarea-no-resize" disabled="true">{{rowData[col.field]}}</textarea>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'translationChoose'">
    <span *ngIf="rowData[col.field]">{{col.translationBaseKey[0] | translate}}</span>
    <span *ngIf="!rowData[col.field]">{{col.translationBaseKey[1] | translate}}</span>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'variableClass'">
    {{ rowData.classVariable ? rowData.classVariable.code : '' }}
  </ng-container>
  
  <ng-container *ngIf="col.type === 'variableType'">
    {{ getVariableType() | translate }}
  </ng-container>
  
  <ng-container *ngIf="col.type === 'innerTranslate'">
    <ng-container *ngIf="rowData[col.field]">
      {{ 'label.common.' + rowData[col.field] | translate }}
    </ng-container>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'logo'">
    <img
      [alt]="rowData[col.field]"
      height="57px"
      width="57px"
      *ngIf="rowData[col.field] !== undefined && rowData[col.field] != null"
      [src]="getSanitizeLogo(rowData[col.field])">
  </ng-container>
  
  <ng-container *ngIf="col.type === 'order'">
    {{ rowData.classVariable && rowData.classVariable.sort ? rowData.classVariable.sort + '.' : '' }}{{ rowData.sort }}
  </ng-container>
  
  <ng-container *ngIf="col.type === 'formula'">
    <div fxLayout="row" fxLayoutGap="0.357rem">
                          <span *ngIf="!rowData[col.fieldExpand]" class="ellipsis">
                              <i>{{ rowData[col.field] }}</i>
                          </span>
      <neq-equation-editor
        *ngIf="rowData[col.fieldExpand]"
        [value]="rowData[col.field]"
        [readOnly]="true"></neq-equation-editor>
      <a (click)="toggleRowExpansion(rowData)">
        <i class="fas" [class.fa-chevron-down]="!rowData[col.fieldExpand]" [class.fa-chevron-up]="rowData[col.fieldExpand]"></i>
      </a>
    </div>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'condition'">
    <div fxLayout="row">
              <span *ngIf="!rowData[col.fieldExpand]" class="equation-formula">
                {{ rowData[col.field] }}
              </span>
      <neq-condition-editor *ngIf="rowData[col.fieldExpand]" [value]="rowData[col.field]"></neq-condition-editor>
      <a (click)="toggleRowExpansion(rowData)">
        <i class="fas" [class.fa-chevron-down]="!rowData[col.fieldExpand]"
           [class.fa-chevron-up]="rowData[col.fieldExpand]"></i>
      </a>
    </div>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'formatList'">
    <div fxLayout="row">
              <span *ngIf="!rowData[col.fieldExpand]" class="equation-formula">
                {{ rowData[col.field] }}
              </span>
      <p style="display:block;width:150px;overflow-wrap:break-word;" *ngIf="rowData[col.fieldExpand]">{{formatList(rowData[col.field])}}</p>
      <a (click)="toggleRowExpansion(rowData)">
        <i class="fas" [class.fa-chevron-down]="!rowData[col.fieldExpand]" [class.fa-chevron-up]="rowData[col.fieldExpand]"></i>
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="col.type === 'booleanDisplay'">
    <mat-checkbox
      [disabled]="true"
      [checked]="returnRawRowDataToDisplay()">
    </mat-checkbox>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'checkCell'">
    <ng-container *ngIf="col.field !== 'overwritten' && col.field !== 'imported'; else importCheck">
      <mat-checkbox
        [disabled]="(col.disable)"
        [ngModel]="(col.checkOutsideNgModel) ? col.checkOutsideNgModel[rowData.code].selected : rowData[col.field]"
        (change)="emitChecked($event)">
      </mat-checkbox>
    </ng-container>
    <ng-template #importCheck>
      <mat-checkbox *ngIf="rowData[col.field] > 0" [checked]="isChecked(rowData)"
                    (change)="emitChecked($event)"></mat-checkbox>
    </ng-template>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'checkedCell'">
    <mat-checkbox [disabled]="true" [ngModel]="rowData[col.field]"></mat-checkbox>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'checkCellMatrixRight' && this.col.checkOutsideNgModel.entities && this.col.checkOutsideNgModel">
    <ng-container *ngIf="!isPrincipalMatrixOfEntity(rowData); else principalMatrixCheckbox">
      <mat-checkbox [checked]="rowData[col.field]" (change)="emitChecked($event)"
                    class="mat-form-field"></mat-checkbox>
    </ng-container>
    <ng-template #principalMatrixCheckbox>
      <mat-checkbox [checked]="true" [disabled]="true"
                    [matTooltip]="'label.admin.entity.manage.matrix' | translate"></mat-checkbox>
    </ng-template>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'predictionTooltip'">
    <span [matTooltip]="rowData.description">{{ rowData[col.field] }}</span>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'variableTooltip'">
    <span [matTooltip]="getVariableTooltip(rowData)">{{ rowData[col.field] }}</span>
  </ng-container>
  
  <ng-container *ngIf="col.type === 'importError'">
    <span [matTooltip]="rowData.errors.join('\n')">{{ rowData.errors.length }}</span>
  </ng-container>
</div>

<ng-container *ngIf="col.type === 'calculationIcon'">
  <calculation-status-icon
    [status]="rowData[col.field]" [tooltipMode]="true" [inTable]="true"
  ></calculation-status-icon>
</ng-container>

